/*
 * @Author: 刘小博
 * @Date: 2023-02-17 11:24:38
 * @LastEditTime: 2023-04-26 18:55:17
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\mg\service-project-manage\modules\serviceProjectRouter.js
 * 服务项目
 */
const serviceProjectRouter = [
  // 芒哥 服务项目
  {
    path: '/mg/projectReport/list',
    name: 'MgProjectReportList',
    component: () =>
      import(
        /*webpackChunkName:"mg" */
        // '@/views/mg/projectReport/list.vue'
        '@/views/mg/service-project-manage/service-project/service-project/Page.vue'
      ),
    meta: {
      SecondaryMenu: '服务项目', //二级菜单
      title: '服务项目',
    },
  },

  // 芒哥 服务项目 查看
  {
    path: '/mg/projectReport-look/list/:client_id/:server_client_id',
    name: 'MgProjectReportListLook',
    component: () =>
      import(
        /*webpackChunkName:"mg" */
        // '@/views/mg/projectReport/lookList.vue' // 需要新建文件夹
        '@/views/mg/service-project-manage/service-project/service-project/View.vue'
      ),
    meta: {
      SecondaryMenu: '服务项目', //二级菜单
      title: '服务项目列表',
      breadcrumb: [
        {
          title: '服务项目',
          name: 'MgProjectReportList',
        },
      ],
    },
  },

  // 芒哥 修改提交时间
  {
    path: '/mg/projectReport/ModifySubmissionTime',
    name: 'ModifySubmissionTime',
    component: () =>
      import(
        /*webpackChunkName:"mg" */
        // '@/views/mg/projectReport/ModifySubmissionTime.vue'
        '@/views/mg/service-project-manage/service-project/service-project/Update.vue'
      ),
    meta: {
      SecondaryMenu: '服务项目', //二级菜单
      title: '修改提交时间',
      breadcrumb: [
        {
          title: '服务项目',
          name: 'MgProjectReportList',
        },
      ],
    },
  },
  // 服务项目导出
  {
    path: '/mg/projectReport/export/:json/:meta_type',
    name: 'serviceManageExport',
    component: () =>
      import(
        /*webpackChunkName:"serviceManageExport" */
        // '@/views/mg/projectReport/serviceManageExport.vue'
        '@/views/mg/service-project-manage/service-project/service-project/Export.vue'
      ),
    meta: {
      SecondaryMenu: '服务项目', //二级菜单
      isMoreMeta: true,
      1: {
        title: '服务项目导出',
        breadcrumb: [
          {
            title: '服务项目',
            name: 'MgProjectReportList',
          },
        ],
      },
      2: {
        title: '服务项目导出',
        breadcrumb: [
          {
            title: '服务项目',
            name: 'MgProjectReportList',
          },
          {
            title: '服务项目列表',
            name: 'MgProjectReportListLook',
          },
        ],
      },
      3: {
        title: '服务项目导出',
        breadcrumb: [
          {
            title: '服务项目',
            name: 'MgProjectReportList',
          },
          {
            title: '服务项目列表',
            name: 'MgProjectReportListLook',
          },
          {
            title: '服务项目明细',
            name: 'serviceProjectDetail',
          },
        ],
      },
    },
  },
  // 芒哥 服务项目明细
  {
    path: '/mg/projectReport/service-project-detail/:server_client_id/:template_id/:name/:json',
    name: 'serviceProjectDetail',
    component: () =>
      import(
        /*webpackChunkName:"mg" */
        // '@/views/mg/projectReport/serviceProjectDetail.vue'
        '@/views/mg/service-project-manage/service-project/service-project/Detail.vue'
      ),
    meta: {
      SecondaryMenu: '服务项目', //二级菜单
      title: '服务项目明细',
      breadcrumb: [
        {
          title: '服务项目',
          name: 'MgProjectReportList',
        },
        {
          title: '服务项目列表',
          name: 'MgProjectReportListLook',
        },
      ],
    },
  },

  // 芒哥 项目成本维护
  {
    path: '/mg/project-cost-caintenance',
    name: 'ProjectCostCaintenance',
    component: () =>
      import(
        /*webpackChunkName:"mg" */
        '@/views/mg/service-project-manage/service-project/project-cost-caintenance/Page.vue'
      ),
    meta: {
      SecondaryMenu: '项目成本维护', //二级菜单
      title: '项目成本维护',
    },
  },

  // 芒哥 项目成本维护 编辑
  {
    path: '/mg/project-cost-caintenance/edit/:type/:json',
    name: 'ProjectCostCaintenanceEdit',
    component: () =>
      import(
        /*webpackChunkName:"mg" */
        '@/views/mg/service-project-manage/service-project/project-cost-caintenance/Edit.vue'
      ),
    meta: {
      SecondaryMenu: '项目成本维护', //二级菜单
      title: '编辑项目成本',
      breadcrumb: [
        {
          title: '项目成本维护',
          name: 'ProjectCostCaintenance',
        },
      ],
    },
  },

  // 芒哥 服务费用维护
  {
    path: '/mg/service-fee-maintenance',
    name: 'ServiceFeeMaintenance',
    component: () =>
      import(
        /*webpackChunkName:"mg" */
        '@/views/mg/service-project-manage/service-project/service-fee-maintenance/Page.vue'
      ),
    meta: {
      SecondaryMenu: '服务费用维护', //二级菜单
      title: '服务费用维护',
    },
  },

  // 芒哥 服务费用维护 导入
  {
    path: '/mg/service-fee-maintenance/import',
    name: 'serviceFeeMaintenanceImport',
    component: () =>
      import(
        /*webpackChunkName:"mg" */
        '@/views/mg/service-project-manage/service-project/service-fee-maintenance/Import.vue'
      ),
    meta: {
      SecondaryMenu: '服务成本维护', //二级菜单
      title: '导入服务费用',
      breadcrumb: [
        {
          title: '服务成本维护',
          name: 'ServiceFeeMaintenance',
        },
      ],
    },
  },
  // 芒哥 分发服务计划
  {
    path: '/mg/distribution-service-plan',
    name: 'DistributionServicePlan',
    component: () =>
      import(
        /*webpackChunkName:"mg" */
        '@/views/mg/service-project-manage/service-project/distribution-service-plan/Page.vue'
      ),
    meta: {
      SecondaryMenu: '分发服务计划', //二级菜单
      title: '分发服务计划',
    },
  },
  // 芒哥 分发服务计划 编辑
  {
    path: '/mg/distribution-service-plan/edit/:server_plan_id',
    name: 'DistributionServiceEdit',
    component: () =>
      import(
        /*webpackChunkName:"mg" */
        '@/views/mg/service-project-manage/service-project/distribution-service-plan/Edit.vue'
      ),
    meta: {
      SecondaryMenu: '分发服务计划', //二级菜单
      title: '编辑计划',
      breadcrumb: [
        {
          title: '分发服务计划',
          name: 'DistributionServicePlan',
        },
      ],
    },
  },
  // 芒哥 分发服务计划 新增计划
  {
    path: '/mg/distribution-service-plan/add-plan/:id',
    name: 'DistributionServiceAddPlan',
    component: () =>
      import(
        /*webpackChunkName:"mg" */
        '@/views/mg/service-project-manage/service-project/distribution-service-plan/AddPlan.vue'
      ),
    meta: {
      SecondaryMenu: '分发服务计划', //二级菜单
      title: '新增计划',
      breadcrumb: [
        {
          title: '分发服务计划',
          name: 'DistributionServicePlan',
        },
      ],
    },
  },

  // 芒哥 项目报告数据
  {
    path: '/mg/projectReport',
    name: 'MgProjectReport',
    component: () =>
      import(
        /*webpackChunkName:"mg" */
        // '@/views/mg/projectReport/index.vue'
        '@/views/mg/service-project-manage/service-project/project-paper/Page.vue'
      ),
    meta: {
      SecondaryMenu: '服务项目', //二级菜单
      title: '项目报告数据',
    },
  },
]
export default serviceProjectRouter
